import {initParallaxSection} from "../components/parallax-section";
import {initThreeIphonesRow} from "../components/three-iphones";
import {scrollImageSection} from "../components/scroll-image-section";

export function initEvpatLanding() {
    if (!$('#evpatoria_landing').length) return;

    initParallaxSection();
    initThreeIphonesRow();
    scrollImageSection();

}
